<template>
  <div class="container">
    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Parts</h1>
      </div>

      <listing-buttons :name="btnName" :route="route"></listing-buttons>
    </div>

    <div class="ui divider"></div>

    <div id="table">
      <div class="filter-bar ui grid">
        <div class="ui equal width stackable grid form px-0">
          <div
            class="column"
            v-for="(field, index) in searchFields"
            :key="field.key"
            :class="{ 'pl-0': index === 0 }"
          >
            <div class="ui input">
              <input
                type="text"
                v-model="search.fields[field.key]"
                @keyup.enter="doFilter"
                :placeholder="field.name"
              />
            </div>
          </div>
          <div class="column">
            <div class="ui button" @click="doFilter">Search</div>
          </div>
          <div class="column align-middle">
            <div class="ui checkbox" style="top: 10px;">
              <input
                type="checkbox"
                name="inactive"
                v-model="search.inactive"
              />
              <label>Inactive</label>
            </div>
          </div>
        </div>
      </div>
      <vuetable
        ref="vuetable"
        :fields="fields"
        :api-url="apiUrl"
        :data="parts"
        pagination-path=""
        :per-page="10"
        :multi-sort="true"
        :sort-order="sortOrder"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="code" slot-scope="part">
          <div class="nowrap">
            {{ part.rowData.code }}
          </div>
        </template>
        <template slot="actions" slot-scope="part">
          <div class="table-button-container">
            <button class="ui button primary" @click="goToDetail(part)">
              <i class="fa fa-edit"></i>
            </button>
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import httpClient from "@/assets/js/HttpClient";

export default {
  name: "MachineAssemby",
  computed: {},
  components: {
    Vuetable,
    VuetablePagination,
  },
  data() {
    return {
      btnName: "Part",
      route: "EditParts",
      showModal: false,
      id: "",
      fields: [
        {
          name: "item",
          title: "Item",
          sortField: "item",
        },
        {
          name: "__slot:code",
          title: "Code",
          sortField: "code",
        },
        {
          name: "description",
          title: "Part Name",
          sortField: "description",
        },
        {
          name: "assembly.parentAssembly.name",
          title: "Assembly",
        },
        {
          name: "assembly.name",
          title: "Sub Assembly",
        },
        {
          name: "assembly.machine.description",
          title: "Machine Name",
        },
        // Buttons Column
        "__slot:actions",
      ],
      sortOrder: [
        {
          field: "code",
          sortField: "code",
          direction: "asc",
        },
      ],
      moreParams: {},
      parts: [],
      apiUrl: apiService.getPartsUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers,
      },
      search: {
        filterText: "",
        filters: "",
        fields: {},
        inactive: false,
      },
      searchFields: [
        {
          name: "Item",
          key: "item",
        },
        {
          name: "Code",
          key: "code",
        },
        {
          name: "Part Name",
          key: "partName",
        },
        {
          name: "Assembly",
          key: "assemblyName",
        },
        {
          name: "Machine Code",
          key: "machineCode",
        },
        {
          name: "Machine Name",
          key: "machineName",
        },
      ],
    };
  },
  mounted() {
    $(".ui.dropdown").dropdown({ fullTextSearch: true });
    this.$events.$on("filter-set", (eventData) => {
      this.onFilterSet(eventData);
    });
    this.$events.$on("filter-reset", () => this.onFilterReset());

    if (this.$route.query.search != null) {
      this.setSearchParams(this.$route.query.search);
    }
  },
  methods: {
    setSearchParams(filterText) {
      if (filterText) {
        const filters = String(filterText).split("|");
        const fields = {};
        filters.forEach((f) => {
          const [key, value] = f.split("-");
          fields[key] = value;
        });

        this.search = Object.assign({}, this.search, { fields });
      }
      this.search.filterText = filterText;
      this.doFilter();
    },
    getParts() {
      apiService.getParts().then((data) => {
        this.parts = data;
      });
    },
    goToDetail(part) {
      this.$router.push({
        name: "EditParts",
        params: {
          id: part.rowData.id,
        },
      });
    },
    partSuccessful(request) {
      (this.code = request.code),
        (this.item = request.item),
        (this.machine = request.machine),
        (this.machineId = request.machineId),
        (this.parentAssembly = request.parentAssembly),
        (this.parentAssemblyId = request.parentAssemblyId),
        (this.subAssembly = request.subAssembly),
        (this.subAssemblyId = request.subAssemblyId),
        (this.sequenceNumber = request.sequenceNumber),
        (this.active = request.active);
    },
    partFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    doFilter() {
      const filterText = Object.keys(this.search.fields)
        .map((k) => this.search.fields[k] ? `${k}-${this.search.fields[k]}` : "")
        .join("|");
      if (this.search.filterText !== filterText) {
        this.search = Object.assign({}, this.search, { filterText });
      }
      this.$events.fire("filter-set", this.search);

      if (this.$route.query.search !== null) {
        this.$set(
          this.search,
          this.search.filterText,
          this.$route.query.search
        );
      } else {
        this.$router.push({
          path: "parts",
          query: { search: this.search.filterText },
        });
      }

      if (this.$route.query.search != this.search.filterText) {
        delete this.$route.query.search;
        this.$router.push({
          path: "parts",
          query: { search: this.search.filterText },
        });
      }
    },
    onFilterSet(data) {
      this.moreParams.filter = data.filterText;
      this.moreParams.inactive = data.inactive || this.active;
      Vue.nextTick(() => {
        this.$refs.vuetable?.refresh();
      });
    },
    onFilterReset() {
      delete this.moreParams.filter;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
  },
  destroyed: function() {
    this.$events.$off("filter-set");
    this.$events.$off("filter-reset");
  },
};
</script>
